import React from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";

import Hero from "../components/home/Hero";
import Stats from "../components/home/Stats";
import WhatWeDo from "../components/home/WhatWeDo";
import Features from "../components/home/Features";
import Plans from "../components/home/Plans";
import FAQ from "../components/home/FAQ";
import Testimonials from "../components/home/Testimonials";

export default function Home() {
    return (
        <div>
            <Navbar />
            <Hero />
            <WhatWeDo />
            <Features />
            <Plans />
            <FAQ />
            <Testimonials />
            <Footer />
        </div>
    );
}
